'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSave"];
import PropTypes from 'prop-types';
import MorphingLinkPopoverBody from './MorphingLinkPopoverBody';
import { PopoverType } from '../../constants/popover';
import { omit } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = Object.assign({
  onSave: PropTypes.func.isRequired
}, omit(['onSubmit'], MorphingLinkPopoverBody.propTypes));
function EditLinkPopoverBodyExpanded(props) {
  const {
      onSave
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-edit small-popover-body p-all-5",
    children: /*#__PURE__*/_jsx(MorphingLinkPopoverBody, Object.assign({}, rest, {
      popoverType: PopoverType.EDIT,
      onSubmit: onSave
    }))
  });
}
EditLinkPopoverBodyExpanded.propTypes = propTypes;
EditLinkPopoverBodyExpanded.displayName = 'EditLinkPopoverBodyExpanded';
export default EditLinkPopoverBodyExpanded;